import { render, staticRenderFns } from "./CuratorsView.vue?vue&type=template&id=3355f6e0"
import script from "./CuratorsView.vue?vue&type=script&lang=js"
export * from "./CuratorsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports